export default __webpack_public_path__ + "static/cardImg1-8b7c0e896a82f088b1c076a5cc4e6129.webp";